import { createAction } from '@reduxjs/toolkit';

// in a separate file to avoid circular dependencies

export const sceneHoverCleared = createAction('viewport/sceneHoverCleared');
